import { render, staticRenderFns } from "./VirtualExhibitionPage.vue?vue&type=template&id=a877d0da&scoped=true"
import script from "./VirtualExhibitionPage.vue?vue&type=script&lang=js"
export * from "./VirtualExhibitionPage.vue?vue&type=script&lang=js"
import style0 from "./VirtualExhibitionPage.vue?vue&type=style&index=0&id=a877d0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a877d0da",
  null
  
)

export default component.exports